import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDownToLine = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.8, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-arrow-down-to-line-icon lucide-arrow-down-to-line", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12 17V3" }), /* @__PURE__ */ React.createElement("path", { d: "m6 11 6 6 6-6" }), /* @__PURE__ */ React.createElement("path", { d: "M19 21H5" }));
const ForwardRef = forwardRef(SvgArrowDownToLine);
export { ForwardRef as ReactComponent };
